import * as Common from '@/tenant/common';
import { StockBalanceJournal } from '../Journal/StockBalanceJournal';

export class StockTakingItem extends StockBalanceJournal{
  constructor(){
    super('StockTakingItem');
    this.binders.stockTaking = new Common.ModelBinder(Common.StockTaking);
  }
  public id: number = 0;
  public stockTakingNo: string = '';
  public stockTaking: Common.StockTaking = null;
  public seqNo: number = 0;
  public stockTakingItemNo: string = '';
  public shelfNo: Common.ShelfNo = null;
  // public get workflowHolder():string{
  //   return this.stockTaking ? this.stockTaking.workflowHolder: super.workflowHolder;
  // }
  // public set workflowHolder(value:string){
  //   super.workflowHolder = value;
  // }  
}

export class StockTakingItemQuery extends Common.LoadQuery {
  constructor(){
    super('StockTakingItemQuery',StockTakingItem);
    this.sort = 'stockTakingItemNo';
  }

  public segment: Common.Segment = null;
  public pic: string = '';
  public warehouse: Common.Counterpart = null;
  public commodity: Common.Commodity = null;
  public sku: Common.SKU = null;  
  public stockTakingNo: string = '';
  public stockTakingItemNo: string = '';
  public refNo: string = '';
  public bookDateFrom: Date = null;
  public bookDateTo: Date = null;
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.StockBalanceJournalStatus = Common.StockBalanceJournalStatus.StockTakingWaiting;
  public holder: string = '';
}

export class StockTakingItemExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery){
    super("",loadQuery);
    this.className = "StockTakingItemExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
  }
  public loadQuery : Common.LoadQuery;
  public sheetName  :string;
}